import { render, staticRenderFns } from "./SongResults.vue?vue&type=template&id=181ddc7f&"
import script from "./SongResults.vue?vue&type=script&lang=js&"
export * from "./SongResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports